import {CHK_HOME_COMPONENT} from '../../constants/reducerTypes';

const initialState = {};
const IsHomeComponentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHK_HOME_COMPONENT:
      if (action.payload === 'HOME') {
        return {
          ...state,
          _isHomeComponent: true,
          _isClientDataComponent: false,
        };
      }
      if (action.payload === 'CLIENTDATA') {
        return {
          ...state,
          _isHomeComponent: false,
          _isClientDataComponent: true,
        };
      }
      // Fall-through to default if neither case above is matched
      return state;

    default:
      return state;
  }
};

export default IsHomeComponentReducer;
